module.exports = __webpack_public_path__ + "static/obot-65f776b90b28e37944fe5158762ff17c.png";